function Mytitle(props) {
  return (
    <>
      <h2 className="mb-4 my-title no-print">{props.title}</h2>
    </>
  );
}

export default Mytitle;
